import { YnetWeatherInHeader } from "../../ynetHeader/components/newYnetWeatherComponenta";
import { SimpleLinkRenderer } from "widgets/commonComponents/inline/hyperLink"
import * as filter from "lodash/filter"
import { isWcmEditor } from "../../../../../config/serverConfig";
import { YnetWeatherInComponenta } from "../../ynetHeader/components/newStyleYnetWeatherComponenta"

interface WeatherProps {
    languageCode: string
    showDescription?:boolean
    imagesDomain?: string
}

declare let window: Window & {
    languageCode: string
}

export class WeatherMultiArticleItem extends React.Component<WeatherProps,{}> {
    public static siteScriptName = "WeatherMultiArticleItem"
    constructor(props) {
        super(props)
    }

    public render() {
        const {showDescription,languageCode, imagesDomain} = this.props
        const lang = isWcmEditor()? WCM_LANG_CODE : (typeof window !== "undefined" &&  languageCode  && languageCode.slice(0, 2)) || "" ;
        return (  
            <> 
            {lang !== "he" ? 
            <div className="weatherItem">
               <span className="title">{getWordTranslation(lang,'עכשיו') }</span>
                <YnetWeatherInHeader showDescription={showDescription} placement={"weatherInMultiArticle"} lang={lang} imagesDomain={imagesDomain} />
                <SimpleLinkRenderer className="goToWeather" href={getWordTranslation(lang, 'linkToWeather')} >
                    {getWordTranslation(lang,'לתחזית המלאה') }
                </SimpleLinkRenderer>             
            </div>
            : <YnetWeatherInComponenta showDescription={showDescription} placement={"weatherInMultiArticle"} imagesDomain={imagesDomain} />}
            </> 
        )
    }
}

export const getWordTranslation = (lang, text: string) => {
    var obj = filter(words, function (v, k) {
        return k === lang;
    });
    var content = filter(obj[0], function (v, k) {
        return k === text;
    })
    return content[0]

}

export const words =
{
    "he": {
        "עכשיו" : "עכשיו",
        'לתחזית המלאה' : 'לתחזית המלאה' ,
        'דני רופ'  :'דני רופ' ,
        'linkToWeather' : 'https://www.ynet.co.il/weather'

    },
    "en": {
        "עכשיו" : "now",
        'לתחזית המלאה'  : 'full forecast',
        'דני רופ'  : 'Dani Roop',
        'linkToWeather' : 'https://www.ynetnews.com/weather'
    },
    "ru": {
        "עכשיו" : "сейчас",
        'לתחזית המלאה'  : 'полный прогноз',
        'דני רופ'  : 'Данни Рупп',
        'linkToWeather' : 'https://www.vesty.co.il/weather'
    },
  
}

